var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2334_27328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.66095 16 0 12.3336 0 7.99593C0 3.6802 3.63811 0 7.99186 0C12.3195 0 16 3.66167 16 7.99593C16 12.3277 12.3342 16 8 16ZM8.01628 12.0672C8.438 12.0672 8.77314 11.7533 8.77314 11.3262V7.6458L8.6999 6.00916L9.3998 6.90483L10.2625 7.80865C10.5149 8.09276 10.9984 8.10323 11.2716 7.84122C11.555 7.56903 11.5283 7.11482 11.2635 6.83969L8.62665 4.15267C8.44218 3.95725 8.23872 3.85954 8.01628 3.85954C7.7884 3.85954 7.58223 3.95725 7.39776 4.15267L4.76094 6.83969C4.50046 7.11072 4.4825 7.57078 4.7528 7.84122C5.02568 8.10286 5.50938 8.09294 5.76195 7.80865L6.6409 6.88855L7.32452 6.00916L7.24313 7.6458V11.3262C7.24313 11.7632 7.58927 12.0672 8.01628 12.0672Z",
    fill: "#FCFCFE",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2334_27328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitDisabled);
export default __webpack_public_path__ + "static/media/submit-disabled.0a6c8685431951111bb70175617826ba.svg";
export { ForwardRef as ReactComponent };